import { apiClient } from '@/services/api';

export interface SchoolsResponse {
  schools: string[];
  other: string;
}

/**
 * The whole D1 catalog in one cacheable response (the server sets a 1h
 * public Cache-Control), filtered client-side. Replaces the old
 * search-per-keystroke endpoint backed by the College Scorecard API.
 *
 * No bundled fallback on purpose: 354 names can't be kept in sync by hand the
 * way the 26 sports can. SchoolPicker degrades to its free-text "Other" branch
 * when this fails, so an athlete can always enter a school.
 */
export const schoolsService = {
  fetch(): Promise<SchoolsResponse> {
    return apiClient.get<SchoolsResponse>('/api/v1/schools', { skipAuth: true });
  },
};
